import React from "react";
import { Camera, SquareArrowOutUpRight, Pencil} from "lucide-react";


export default function ProfileHeader({ user, onViewProfile, onEditProfile }) {
  const initials = user?.name
    ? user.name.split(" ").map((n) => n[0]).join("").slice(0, 2)
    : "U";

  return (
    <div className="w-full">
      <div
        className="
          w-full h-[50px]
          bg-acs-primary-navy 
          rounded-t-xl
          bg-gradient-to-br from-[#1A2454] to-[#0D1332]
        "
      />

      <div
        className="
          px-fluid-3 pb-fluid-3
          flex flex-col items-center text-center
          -mt-[3.2rem]
        "
      >
       <div className="relative">
        {/* Avatar Circle */}
        <div
            className="
            w-[5rem] h-[5rem] rounded-full
            bg-[#223688] dark:bg-[#31C4AB]
            flex items-center justify-center
            text-white dark:text-acs-dark-surface
            text-fluid-2xl font-semibold
            shadow-lg border-4 border-white dark:border-acs-dark-surface
            "
        >
            {initials}
        </div>

        {/* Lucide Camera Icon */}
        <button
            className="
            absolute bottom-0 right-0 
            w-[1.8rem] h-[1.8rem]
            rounded-full 
            bg-white dark:bg-acs-dark-surface 
            flex items-center justify-center 
            shadow-md border border-gray-300 dark:border-gray-600
            "
            onClick={() => console.log('Open upload modal')}
        >
            <Camera className="w-4 h-4 text-gray-700 dark:text-gray-200" />
        </button>
        </div>


        <h3
          className="
            mt-fluid-2
            text-fluid-xl font-semibold 
            text-gray-900 dark:text-white
          "
        >
          {user?.name || "User"}
        </h3>

        <p
          className="
            text-fluid-sm 
            text-gray-600 dark:text-gray-300
          "
        >
          {user?.email}
        </p>

        {/* Buttons */}
        <div className="mt-fluid-2 flex gap-fluid-2">
        {/* View */}
        <button
            onClick={() => onViewProfile?.(user)}
            className="
            px-fluid-2 py-fluid-1.5 
            text-fluid-sm font-medium 
            rounded-lg 
            bg-[#223688] text-white 
            dark:bg-[#31C4AB] dark:text-acs-dark-surface
            hover:opacity-90 transition
            flex items-center gap-fluid-1
            "
        >
             View Profile
            <SquareArrowOutUpRight className="w-4 h-4" />
        </button>

        {/*/!* Edit *!/*/}
        {/*<button*/}
        {/*    onClick={() => onViewProfile?.(user)}*/}
        {/*    className="*/}
        {/*    px-fluid-2 py-fluid-1.5 */}
        {/*    text-fluid-sm font-medium */}
        {/*    rounded-lg border */}
        {/*    border-gray-300 text-gray-700 */}
        {/*    dark:border-acs-dark-border dark:text-gray-300*/}
        {/*    hover:bg-gray-100 dark:hover:bg-acs-dark-hover */}
        {/*    transition*/}
        {/*    flex items-center gap-fluid-1*/}
        {/*    "*/}
        {/*>*/}
        {/*    Edit Profile*/}
        {/*    <Pencil className="w-4 h-4" />*/}
        {/*</button>*/}
        </div>

      </div>
    </div>
  );
}
